import Repository from '../axios'

const resource = "/landlord/go_cardless"

export default {
  createCustomer (payload){
    return Repository.post(`${resource}/customers`,payload)
  }
}
